import React from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import './SiteFooter.css'
import FullLogo from '../../assets/images/FullLogo.png'
import { useAuth } from '../../hooks/AuthProvider'

function SiteFooter() {
    const currentYear = new Date().getFullYear();
    const auth = useAuth();
    return (
        <footer className='site-footer-footer'>
            <Container>
                <Row>
                    
                    <Col>
                        <h4 className='sitefooter-header'>Quick Links</h4>
                        <ul className='sitefooter-link-list'>
                            <li>
                                <a
                                    href='http://www.usjersey.com/'
                                    rel='noopener'
                                    target='blank'>
                                    USJersey
                                </a>
                            </li>
                            <li>
                                <a
                                    href='https://infojersey.usjersey.com'
                                    rel='noopener'
                                    target='blank'>
                                    InfoJersey
                                </a>
                            </li>
                            <li>
                                <a
                                    href='https://usjerseyjournal.com/'
                                    rel='noopener'
                                    target='blank'>
                                    Jersey Journal
                                </a>
                            </li>
                        </ul>
                    </Col>
                    <Col>
                        <h4 className='sitefooter-header'>Jersey Services</h4>
                        <ul className='sitefooter-link-list'>
                            <li>
                                <a
                                    href='https://jerseytags.usjersey.com'
                                    rel='noopener'
                                    target='blank'>
                                    Jersey Tags
                                </a>
                            </li>
                            <li>
                                <a
                                    href='https://greenbook.usjersey.com'
                                    rel='noopener'
                                    target='blank'>
                                    GreenBook
                                </a>
                            </li>
                            <li>
                                <a
                                    href='https://infojersey.usjersey.com/publictools/BullseyeV2/'
                                    rel='noopener'
                                    target='blank'>
                                    Bullseye
                                </a>
                            </li>
                        </ul>
                    </Col>

                    <Col>
                        <h4 className='sitefooter-header'>Contact</h4>
                        <ul className='sitefooter-link-list'>
                            <li>
                            <Link to="/contact">Contact Information</Link>
                            </li>                            
                        </ul>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='site-legal-container'>
                <Container>
                    <Row className='align-items-end'>
                        <Col>
                            <Image src={FullLogo} height='75' />
                            <h2 className=' site-legal-company-name'>Jersey Directory</h2>
                            <h5>Copyright &copy; {currentYear} American Jersey Cattle Association</h5>
                        </Col>
                        <Col>
                            <ul className='site-legal-link-list'>
                                <li>
                                    <Link className='nav-link hover-red' to="/about">FAQ</Link>
                                </li>
                                <li>
                                    /
                                </li>
                                <li>
                                    <Link className='nav-link hover-red' to="/login">Login</Link>
                                </li>
                                <li>
                                    /
                                </li>
                                <li>
                                    <Link className='nav-link hover-red' onClick={() => auth.logOut()} to="/">Logout</Link>
                                </li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </footer>

    )
}

export default SiteFooter